import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {Link} from "react-router-dom";
import {motion} from 'framer-motion';
import {Container} from 'react-bootstrap';

import {ReactCompareSlider, ReactCompareSliderImage} from 'react-compare-slider';

import Logo from './Logo';
import AllHeads from './AllHeads';
import {useLanguage} from './LanguageProvider';
import Footer from './Footer';

import buySliderImg1 from '../images/b1.jpg';
import buySliderImg2 from '../images/b2.jpg';
import rentSliderImg1 from '../images/r1.jpg';
import rentSliderImg2 from '../images/r2.jpg';

import bh1 from '../images/bh1.jpg';
import bh2 from '../images/bh2.jpg';
import bh3 from '../images/bh3.jpg';
import bh4 from '../images/bh4.jpg';
import bh5 from '../images/bh5.jpg';
import bh6 from '../images/bh6.jpg';

import ba1 from '../images/ba1.jpg';
import ba2 from '../images/ba2.jpg';
import ba3 from '../images/ba3.jpg';
import ba4 from '../images/ba4.webp';

import bl1 from '../images/bl1.jpg';
import bl2 from '../images/bl2.jpg';

import bo1 from '../images/bo1.jpg';
import bo2 from '../images/bo2.jpg';
import bo3 from '../images/bo3.jpg';
import bo4 from '../images/bo4.jpg';

import rh1 from '../images/rh1.jpg';

import ra1 from '../images/ra1.jpg';
import ra2 from '../images/ra2.jpg';
import ra3 from '../images/ra3.jpg';

import rl1 from '../images/rl1.png';

import ro1 from '../images/ro1.jpg';
import ro2 from '../images/ro2.jpg';
import ro3 from '../images/ro3.jpeg';
import ro4 from '../images/ro4.webp';

function Type() {

    const {type} = useParams();
    const {language} = useLanguage();

    const [randomHouseImg, setRandomHouseImg] = useState(null);
    const [randomApartmentsImg, setRandomApartmentsImg] = useState(null);
    const [randomLandImg, setRandomLandImg] = useState(null);
    const [randomOfficesImg, setRandomOfficesImg] = useState(null);

    useEffect(() => {
        if (type === 'buy') {
            const buyHouseImages = [bh1, bh2, bh3, bh4, bh5, bh6];
            const randomHouse = buyHouseImages[Math.floor(Math.random() * buyHouseImages.length)];
            setRandomHouseImg(randomHouse);

            const buyApartmentsImages = [ba1, ba2, ba3, ba4];
            const randomApartments = buyApartmentsImages[Math.floor(Math.random() * buyApartmentsImages.length)];
            setRandomApartmentsImg(randomApartments);

            const buyLandImages = [bl1, bl2];
            const randomLand = buyLandImages[Math.floor(Math.random() * buyLandImages.length)];
            setRandomLandImg(randomLand);

            const buyOfficesImages = [bo1, bo2, bo3, bo4];
            const randomOffices = buyOfficesImages[Math.floor(Math.random() * buyOfficesImages.length)];
            setRandomOfficesImg(randomOffices);

        } else if (type === 'rent') {
            setRandomHouseImg(rh1);

            const buyApartmentsImages = [ra1, ra2, ra3];
            const randomApartments = buyApartmentsImages[Math.floor(Math.random() * buyApartmentsImages.length)];
            setRandomApartmentsImg(randomApartments);

            setRandomLandImg(rl1);

            const buyOfficesImages = [ro1, ro2, ro3, ro4];
            const randomOffices = buyOfficesImages[Math.floor(Math.random() * buyOfficesImages.length)];
            setRandomOfficesImg(randomOffices);
        }
    }, [type]);


    return (
        <>
            <div className='my-header'>
                <Container className='cont-header'>
                    <Logo/>
                    <AllHeads/>
                </Container>
            </div>

            <Container className='content-start'>

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 0.4 } }}
                    exit={{ opacity: 0, transition: { duration: 0.25 } }}
                >
                    <div
                        className='title-size'>{language === 'en' ? 'EXCLUSIVE OFFERS' : 'ЕКСКЛЮЗИВНІ ПРОПОЗИЦІЇ'}</div>

                    <ReactCompareSlider
                        className='compare-slider-size mt-4'
                        // boundsPadding={0}
                        itemOne={
                            <>
                                <div
                                    className='slider-button slider-button-size slider-button-before'
                                    style={{fontWeight: '100'}}
                                >
                                    {language === 'en' ? 'Review' : 'Переглянути'}
                                </div>
                                <Link
                                    className='slider-button slider-button-size slider-button-before'
                                    to={type === 'buy' ? '/buy/apartments/212765963' : '/rent/apartments/111776036'}
                                    style={{zIndex: '10', opacity: '0'}}
                                >
                                    {language === 'en' ? 'Review' : 'Переглянути'}
                                </Link>

                                <Link
                                    className='slider-button slider-button-size slider-button-after'
                                    to={type === 'buy' ? '/buy/apartments/212772600' : '/rent/offices/1488262'}
                                    style={{zIndex: '10', opacity: '0'}}
                                >
                                    {language === 'en' ? 'Review' : 'Переглянути'}
                                </Link>

                                <ReactCompareSliderImage
                                    alt="Image one"
                                    src={type === 'buy' ? buySliderImg1 : rentSliderImg1}
                                />
                            </>
                        }
                        itemTwo={
                            <>
                                <div
                                    className='slider-button slider-button-size slider-button-after'
                                    style={{fontWeight: '100'}}
                                >
                                    {language === 'en' ? 'Review' : 'Переглянути'}
                                </div>
                                <ReactCompareSliderImage
                                    alt="Image two"
                                    src={type === 'buy' ? buySliderImg2 : rentSliderImg2}
                                />

                            </>
                        }
                        keyboardIncrement="5%"
                        position={50}
                    />

                    {type === 'buy' && <div
                        className='title-size mt-5'>{language === 'en' ? 'BUYING CATEGORIES' : 'КАТЕГОРІЇ ПРОДАЖУ'}</div>}
                    {type === 'rent' && <div
                        className='title-size mt-5'>{language === 'en' ? 'RENT CATEGORIES' : 'КАТЕГОРІЇ ОРЕНДИ'}</div>}

                    <div className="categories-box mt-4">

                        <div className='category-box'>
                            <Link
                                className='text-decoration-none'
                                to={`/${type}/apartments`}
                                onClick={() => {
                                    window.scroll(0, 0);
                                }}
                            >
                                <div className='category-img-box'>
                                    <img className='category-img' src={randomApartmentsImg} alt=''/>
                                </div>
                                <h4 className="category-txt mt-3">{language === 'en' ? 'Apartments' : 'Квартири'}</h4>
                            </Link>
                        </div>

                        <div className='category-box'>
                            <Link
                                className='text-decoration-none'
                                to={`/${type}/houses`}
                                onClick={() => {
                                    window.scroll(0, 0);
                                }}
                            >
                                <div className='category-img-box'>
                                    <img className='category-img' src={randomHouseImg} alt=''/>
                                </div>
                                <h4 className="category-txt mt-3">{language === 'en' ? 'Houses' : 'Будинки'}</h4>
                            </Link>
                        </div>

                    </div>

                    <div className="categories-box">

                        <div className='category-box'>
                            <Link
                                className='text-decoration-none'
                                to={`/${type}/land`}
                                onClick={() => {
                                    window.scroll(0, 0);
                                }}
                            >
                                <div className='category-img-box'>
                                    <img className='category-img' src={randomLandImg} alt=''/>
                                </div>
                                <h4 className="category-txt mt-3">{language === 'en' ? 'Land' : 'Земля'}</h4>
                            </Link>
                        </div>

                        <div className='category-box'>
                            <Link
                                className='text-decoration-none'
                                to={`/${type}/offices`}
                                onClick={() => {
                                    window.scroll(0, 0);
                                }}
                            >
                                <div className='category-img-box'>
                                    <img className='category-img' src={randomOfficesImg} alt=''/>
                                </div>
                                <h4 className="category-txt mt-3">{language === 'en' ? 'Commercial' : 'Комерційна нерухомість'}</h4>
                            </Link>
                        </div>

                    </div>

                    <Footer/>
                </motion.div>
            </Container>

        </>
    );
}

export default Type;
